import { render, staticRenderFns } from "./BookingInfos.vue?vue&type=template&id=6df371f9&scoped=true&"
import script from "./BookingInfos.vue?vue&type=script&lang=ts&"
export * from "./BookingInfos.vue?vue&type=script&lang=ts&"
import style0 from "./BookingInfos.vue?vue&type=style&index=0&id=6df371f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df371f9",
  null
  
)

export default component.exports